import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import SearchIcon from "@mui/icons-material/Search";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { TabPanel } from "./TabPanelComponent";
import { ProductComponent } from "./ProductComponent";
import { BASE_URL_API, MARKET_BASE_URL_API } from "../Const";
import { BasketComponent } from "./BasketComponent";
import AliceCarousel from "react-alice-carousel";
import PositionedMenu from "./PositionedMenu";
import { BackButton, BottomMenu } from './HookUtils';
import { Link } from "react-router-dom";

export class ProductCollectionComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchedCategories: [],
            value: 0,
            marketInfo: {},
            open: false,
            popUpOpen: false,
        };
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'market/' + this.props.id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                if (results.code === 200) {
                    this.setState({ marketInfo: results.data });
                }
            })
            .catch((error) => console.log("market error", error));

        fetch(BASE_URL_API + 'subCategory?market_id=' + this.props.id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                this.setState({ fetchedCategories: results.data });
            })
            .catch((error) => console.log("subcategory error", error));
    }

    handleChange = (event, newValue) => {
        this.setState({ value: newValue });
    };

    render() {

        const { marketInfo, value, fetchedCategories } = this.state;

        return (
            <div>
                <AppBar style={{ background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex' }}>
                    <ToolbarMui>
                        <IconButton
                            color="inherit"
                            edge="end"
                            sx={{ ...(this.state.open && { display: 'none' }) }}
                            size="large" />

                        <ListItemText align="center">
                            <strong style={{
                                width: '90%',
                                fontSize: 18,
                                overflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                color: 'black'
                            }}>{marketInfo.name}</strong>
                        </ListItemText>

                        <IconButton component={Link} to={"/search"} style={{ color: 'black' }} size="large"><SearchIcon /></IconButton>
                        <IconButton style={{ color: 'black' }} size="large"><BasketComponent /></IconButton>
                        <PositionedMenu marketInfo={marketInfo} />
                        <BackButton />
                    </ToolbarMui>

                    <Tabs
                        variant="scrollable"
                        value={value}
                        onChange={this.handleChange}
                        textColor="secondary"
                        indicatorColor="primary"
                    >
                        <Tab key="all-products" label="همه محصولات" />
                        {fetchedCategories.map((category) => (
                            <Tab key={category.id} label={category.title} />
                        ))}
                    </Tabs>
                </AppBar>
                {/* ALL PRODUCTS TAB */}
                <TabPanel value={value} index={0}>
                    <div style={{ marginTop: 80 }} />

                    <AliceCarousel
                        autoPlay
                        autoPlayStrategy="none"
                        autoPlayInterval={2500}
                        animationDuration={1000}
                        infinite
                        touchTracking={false}
                        disableButtonsControls
                    >
                        {
                            marketInfo.pictures?.map((item, index) => (
                                <div key={index} align='center'>
                                    <img
                                        style={{
                                            marginBottom: 15,
                                            marginTop: 15,
                                            width: 280,
                                            height: 280,
                                            objectFit: 'cover'
                                        }}
                                        src={MARKET_BASE_URL_API + item.url}
                                        alt=""
                                    />
                                </div>
                            ))
                        }
                    </AliceCarousel>

                    <p key={marketInfo.content} style={{
                        fontSize: 14,
                        color: 'black',
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'break-word',
                        textAlign: 'right'
                    }}>
                        <strong>{marketInfo.content}</strong>
                    </p>

                    <ProductComponent market_id={this.props.id} category_id={-1} />
                </TabPanel>
                {/* CATEGORIZED PRODUCTS */}
                {fetchedCategories.map((category, index) => (
                    <TabPanel key={category.id} value={value} index={index + 1}>
                        <div style={{ marginTop: 80 }} />

                        <AliceCarousel
                            autoPlay
                            autoPlayStrategy="none"
                            autoPlayInterval={2500}
                            animationDuration={1000}
                            infinite
                            touchTracking={false}
                            disableButtonsControls
                        >
                            {
                                marketInfo.pictures?.map((item, index) => (
                                    <div key={index} align='center'>
                                        <img
                                            style={{
                                                marginBottom: 15,
                                                marginTop: 15,
                                                width: 280,
                                                height: 280,
                                                objectFit: 'cover'
                                            }}
                                            src={MARKET_BASE_URL_API + item.url}
                                            alt=""
                                        />
                                    </div>
                                ))
                            }
                        </AliceCarousel>

                        <p style={{
                            fontSize: 14,
                            color: 'black',
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word',
                            textAlign: 'right'
                        }}>
                            <strong>{marketInfo.content}</strong>
                        </p>

                        <ProductComponent market_id={this.props.id} category_id={category.id} />
                    </TabPanel>
                ))}
                <BottomMenu />
            </div>
        );
    }
}
